import { z } from 'zod';
import {
  BOOLEAN_FILTER_REGEX,
  CODE_FILTER_REGEX,
  DATE_FILTER_REGEX,
  PICKLIST_FILTER_REGEX,
} from '@/common/utils/compact-filters/filterOperators';

export const compactPicklistFilterSchema = z
  .string()
  .regex(
    PICKLIST_FILTER_REGEX,
    'Invalid picklist filter format. Expected: operator_value1-value2 (e.g., in_50 or in_30-34)',
  )
  .optional();

export const compactCodeFilterSchema = z
  .string()
  .regex(
    CODE_FILTER_REGEX,
    'Invalid code filter format. Expected: operator_code1,code2 (e.g., in_US, in_US,CA or in_US:CA)',
  )
  .optional();

export const compactBooleanFilterSchema = z
  .string()
  .regex(
    BOOLEAN_FILTER_REGEX,
    'Invalid boolean filter format. Expected: operator_value (e.g., is_true or is_false)',
  )
  .optional();

export const compactDateFilterSchema = z
  .string()
  .regex(
    DATE_FILTER_REGEX,
    'Invalid date filter format. Expected: operator_YYYY-MM-DD (e.g., is_2025-11-12, after_2025-11-04, or in_2024-01-01_2024-12-31)',
  )
  .optional();
